var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWait({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 5C13.3701 5 12.8575 5.5126 12.8575 6.14252C12.8575 6.77467 13.3701 7.28504 14.0001 7.28504C14.6322 7.28504 15.1426 6.77456 15.1426 6.14252C15.1426 5.5126 14.6321 5 14.0001 5ZM6 13.0001C6 13.6322 6.5126 14.1426 7.14252 14.1426C7.77467 14.1426 8.28504 13.6321 8.28504 13.0001C8.28504 12.3701 7.77456 11.8575 7.14252 11.8575C6.5126 11.8575 6 12.3701 6 13.0001ZM19.6585 7.34373C20.1038 7.78905 20.1038 8.51237 19.6585 8.9598C19.211 9.40512 18.4877 9.40512 18.0403 8.9598C17.595 8.51237 17.595 7.78902 18.0403 7.34373C18.4877 6.8963 19.211 6.8963 19.6585 7.34373ZM9.95984 17.0404C10.4052 17.4878 10.4052 18.2112 9.95984 18.6586C9.51241 19.1039 8.78906 19.1039 8.34377 18.6586C7.89634 18.2112 7.89634 17.4878 8.34377 17.0404C8.78909 16.5951 9.51241 16.5951 9.95984 17.0404ZM8.34377 7.34373C7.89634 7.78905 7.89634 8.51237 8.34377 8.9598C8.78909 9.40512 9.51241 9.40512 9.95984 8.9598C10.4052 8.51237 10.4052 7.78902 9.95984 7.34373C9.51241 6.8963 8.78906 6.8963 8.34377 7.34373ZM14.0001 18.715C13.3702 18.715 12.8576 19.2276 12.8576 19.8575C12.8576 20.4896 13.3702 21 14.0001 21C14.6322 21 15.1426 20.4895 15.1426 19.8575C15.1426 19.2276 14.6321 18.715 14.0001 18.715Z",
    fill: "#2361FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.d8b7269d29f49dfab16137def42e9ab8.svg";
export { ForwardRef as ReactComponent };